// Die Suchmaske darf nie in der Vergangenheit liegen (Simon, 24.09.2026).
// Liegt "von" vor morgen, wandert der ganze Zeitraum gleich lang nach vorn:
// "von" = morgen, "bis" = morgen + bisherige Spanne.
//
// Zwei Formen desselben Zeitraums im Store:
//   travelDate {from, until|to}  ISO "YYYY-MM-DD" (resetSearch: JSON-String mit Anfuehrungszeichen)
//   searchDate {start, end}      "DD.MM.YYYY" (Anzeige der Suchmaske)

const DAY = 24 * 3600 * 1000;

const tomorrow = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return new Date(d.getTime() + DAY);
};

const pad = (n) => String(n).padStart(2, "0");
const toIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const toDe = (d) => `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;

const parseIso = (s) => {
  const m = /(\d{4})-(\d{2})-(\d{2})/.exec(String(s ?? ""));
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};
const parseDe = (s) => {
  const m = /(\d{2})\.(\d{2})\.(\d{4})/.exec(String(s ?? ""));
  return m ? new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])) : null;
};

// Verschiebung in Tagen, damit "von" frühestens morgen ist (0 = nichts zu tun).
const shiftDays = (from) => {
  if (!from) return 0;
  const diff = Math.round((tomorrow().getTime() - from.getTime()) / DAY);
  return diff > 0 ? diff : 0;
};

const addDaysLocal = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

export const futureTravelDate = (travelDate) => {
  if (!travelDate || typeof travelDate !== "object") return travelDate;
  const days = shiftDays(parseIso(travelDate.from));
  if (!days) return travelDate;
  const next = { ...travelDate };
  for (const key of ["from", "until", "to"]) {
    const d = parseIso(travelDate[key]);
    if (d) next[key] = toIso(addDaysLocal(d, days));
  }
  return next;
};

export const futureSearchDate = (searchDate) => {
  if (!searchDate || typeof searchDate !== "object") return searchDate;
  const days = shiftDays(parseDe(searchDate.start));
  if (!days) return searchDate;
  const next = { ...searchDate };
  for (const key of ["start", "end"]) {
    const d = parseDe(searchDate[key]);
    if (d) next[key] = toDe(addDaysLocal(d, days));
  }
  return next;
};

// Auf den ganzen Such-State anwenden (Immer-Draft oder Objekt).
export const keepSearchInFuture = (state) => {
  if (state.travelDate) state.travelDate = futureTravelDate(state.travelDate);
  if (state.searchDate) state.searchDate = futureSearchDate(state.searchDate);
};
